import { EKeyboardKey } from '@/utils/menu.utils';

export const getTabbedDetailDialogNavigationIndex = (
  key: string,
  currentIndex: number,
  tabCount: number,
): number | null => {
  if (tabCount <= 0) return null;
  if (key === EKeyboardKey.Home) return 0;
  if (key === EKeyboardKey.End) return tabCount - 1;
  if (key === EKeyboardKey.Right) return (currentIndex + 1) % tabCount;
  if (key === EKeyboardKey.Left) return (currentIndex - 1 + tabCount) % tabCount;
  return null;
};
